import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { BREAKPOINTS_VALUE, COLORS } from './Styles/Constants';

/**
 * @constant
 * @description Material-UI breakpoints configuration for responsive design.
 * Defines screen size breakpoints based on device types.
 *
 * @type {Object}
 * @property {number} xs - Extra small devices (0px and up)
 * @property {number} sm - Small devices (600px and up) - Phablet
 * @property {number} md - Medium devices (960px and up) - Tablet
 * @property {number} lg - Large devices (1278px and up) - Laptop
 * @property {number} xl - Extra large devices (1450px and up) - Desktop
 *
 * @see BREAKPOINTS_VALUE - Source breakpoint values
 */
const breakpoints = createBreakpoints({
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
        xs: 0,
        sm: BREAKPOINTS_VALUE.PHABLET,
        md: BREAKPOINTS_VALUE.TABLET,
        lg: BREAKPOINTS_VALUE.LAPTOP,
        xl: BREAKPOINTS_VALUE.DESKTOP
    }
});

/**
 * @constant
 * @description Material-UI theme configuration object for the Devotee CMS application.
 * Contains palette colors, breakpoints, and component style overrides.
 *
 * @type {Object}
 * @property {Object} palette - Color palette configuration
 * @property {Object} palette.primary - Primary color variants (blue)
 * @property {Object} palette.secondary - Secondary color variants (pink/red)
 * @property {Object} breakpoints - Responsive breakpoints configuration
 * @property {Object} overrides - Component-specific style overrides
 * @property {Object} overrides.MuiAppBar - AppBar component customization
 * @property {Object} overrides.MuiButton - Button component customization
 *
 * @example
 * import { createTheme } from '@material-ui/core/styles';
 * import { THEME_SETTINGS } from './themeSettings';
 *
 * const theme = createTheme(THEME_SETTINGS);
 *
 * @see COLORS - Color constants
 * @see BREAKPOINTS_VALUE - Breakpoint values
 */
export const THEME_SETTINGS = {
    palette: {
        primary: {
            light: COLORS.PRIMARY_LIGHT,
            main: COLORS.PRIMARY,
            dark: COLORS.PRIMARY_DARK
        },
        secondary: {
            light: COLORS.SECONDARY_LIGHT,
            main: COLORS.SECONDARY,
            dark: COLORS.SECONDARY_DARK
        }
    },
    breakpoints,
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: `0 0px 5px 0px ${COLORS.PRIMARY}`,
                height: '70px',
                [breakpoints.down('md')]: {
                    height: '60px'
                }
            }
        },
        MuiButton: {
            contained: {
                color: 'white',
                fontSize: '16px',
                minHeight: '42px',
                minWidth: '150px',
                [breakpoints.down('lg')]: {
                    minHeight: '40px',
                    fontSize: '14px'
                },
                [breakpoints.down('sm')]: {
                    minWidth: '120px',
                    minHeight: '32px',
                    fontSize: '14px'
                }
            },
            containedPrimary: {
                color: 'white'
            },
            containedSecondary: {
                color: 'white'
            },
            outlinedPrimary: {
                borderRadius: '25px',
                border: '1px solid #000000',
                color: '#000000'
            },
            sizeLarge: {
                fontSize: '16px'
            }
        }
    }
    // typography: {
    // 	useNextVariants	: true,
    // 	fontFamily		: "Gotham Book",
    // }
};
